export const SUB_ROUTE_OUTRIGHTS = 'outrights' as const;
export const SUB_ROUTE_TOURNAMENT_PREVIEW = 'tournament-preview' as const;

const LeaguePageSubRoutes = {
	OUTRIGHTS: SUB_ROUTE_OUTRIGHTS,
	TOURNAMENT_PREVIEW: SUB_ROUTE_TOURNAMENT_PREVIEW
} as const;

export default LeaguePageSubRoutes;
